<script>
import HalfDashCard from "@/components/Cards/HalfDashCard";
import DaylogService from "@/services/DaylogService";
import dayjs from "dayjs";

export default {
    props: {
        stats: {},
        selectedDate: {}
    },
    components: {
        HalfDashCard
    },
    data() {
        return {
            loading: true,
            mdata: {},
            meta: {}
        };
    },
    async created() {
        if (this.$isDE) {
            await this.fetchData();
            this.loading = false;
        }
    },
    methods: {
        async fetchData() {
            try {
                const ds = dayjs(this.selectedDate);
                const { data } = await DaylogService.GET_myData(
                    ds.format("YYYY"),
                    ds.format("M")
                );
                this.mdata = data.data;
                this.meta = data.meta;
            } catch (e) {
                console.log("fd e", e);
            }
        }
    }
};
</script>

<template>
    <div class="row">
        <div class="col-12 col-md">
            <half-dash-card
                :title="$t('dashboard.box_hours_today')"
                :value="stats.time_today | toTime"
                icon="far fa-clock"
                :navigate="{ name: 'Dashboard' }"
            >
            </half-dash-card>
        </div>

        <div class="col-12 col-md">
            <half-dash-card
                :title="$t('dashboard.box_hours_this_week')"
                :value="stats.time_week | toTime"
                icon="far fa-calendar-week"
                :navigate="{ name: 'DashboardHoursWeek' }"
            >
            </half-dash-card>
        </div>

        <div class="col-12 col-md">
            <half-dash-card
                :title="$t('dashboard.box_hours_this_month')"
                :value="stats.time_month | toTime"
                icon="far fa-calendar-alt"
                :navigate="{ name: 'DashboardHoursMonth' }"
            >
            </half-dash-card>
        </div>
        <div class="col-12 col-md" v-if="$isDE">
            <v-loader :loading="loading" v-if="loading" />
            <half-dash-card
                v-else
                :title="$t('daylogs.statbox_clock_hours_this_month')"
                :value="meta.sums.month.total_time_sum | toTime"
                icon="far fa-stopwatch"
                :navigate="{ name: 'DashboardOpenDays' }"
            >
            </half-dash-card>
        </div>

        <div class="col-12 col-md">
            <half-dash-card
                :title="$t('dashboard.box_open_days')"
                :value="stats.open_days"
                icon="far fa-calendar-exclamation"
                :navigate="{ name: 'DashboardOpenDays' }"
            >
            </half-dash-card>
        </div>
        <div class="col-12 col-md" v-if="false">
            <half-dash-card
                :title="$t('dashboard.box_avg_WK_MON')"
                icon="far fa-tachometer-average"
                :navigate="{ name: 'DashboardAverages' }"
                :value="`${avgWk} | ${avgMon}`"
            >
            </half-dash-card>
        </div>
    </div>
</template>
